// 右上角当前用户胶囊 — 头像 + 昵称/邮箱 + 下拉菜单
// UX-2026-05-27: 菜单加 帮助文档 + 退出登录, 账号设置改为跳 /settings 单独页
// (不再用 Modal, 跟 UX 文档对齐)

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../lib/use-auth";
import { useI18n } from "../lib/i18n";
import { Avatar } from "./Avatar";
import { useDialog } from "./Dialog";

export function UserChip() {
  const { user, signOut } = useAuth();
  const { t } = useI18n();
  const dlg = useDialog();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  if (!user) return null;

  const label = user.display_name || user.email;

  async function doSignOut() {
    setOpen(false);
    const ok = await dlg.confirm({
      title: t("nav.logout"),
      message: "确认退出当前账号？",
      confirmLabel: t("nav.logout"),
      variant: "danger",
    });
    if (!ok) return;
    await signOut();
    navigate("/");
  }

  return (
    <div className="user-chip">
      <button
        type="button"
        className="user-chip__btn"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Avatar seed={user.email} label={label} size={24} src={user.avatar_url} />
        <span className="user-chip__email">{label}</span>
        <span className="user-chip__caret" aria-hidden>
          ▾
        </span>
      </button>
      {open && (
        <>
          <div className="user-chip__scrim" onClick={() => setOpen(false)} />
          <menu className="user-chip__menu">
            <button
              type="button"
              className="user-chip__item"
              onClick={() => {
                setOpen(false);
                navigate("/settings");
              }}
            >
              {t("nav.settings")}
            </button>
            <button
              type="button"
              className="user-chip__item"
              onClick={() => {
                setOpen(false);
                navigate("/help");
              }}
            >
              {t("nav.help")}
            </button>
            <button
              type="button"
              className="user-chip__item user-chip__item--danger"
              onClick={() => void doSignOut()}
            >
              {t("nav.logout")}
            </button>
          </menu>
        </>
      )}
    </div>
  );
}
